import admin from '../components/admin'
import auth from '../components/auth'

export default {
  install (Vue) {
    Vue.component(admin.name, admin)
    Vue.component(auth.name, auth)
  }
}
